/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetIndicatorTestDto } from './GetIndicatorTestDto';
import {
    GetIndicatorTestDtoFromJSON,
    GetIndicatorTestDtoFromJSONTyped,
    GetIndicatorTestDtoToJSON,
} from './GetIndicatorTestDto';

/**
 * 
 * @export
 * @interface GetNormDto
 */
export interface GetNormDto {
    /**
     * 
     * @type {string}
     * @memberof GetNormDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetNormDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNormDto
     */
    condition?: string | null;
    /**
     * 
     * @type {number}
     * @memberof GetNormDto
     */
    confidenceInterval?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetNormDto
     */
    probability?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetNormDto
     */
    criticalValue?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNormDto
     */
    group?: string | null;
    /**
     * 
     * @type {GetIndicatorTestDto}
     * @memberof GetNormDto
     */
    indicatorTest?: GetIndicatorTestDto | null;
    /**
     * 
     * @type {number}
     * @memberof GetNormDto
     */
    examinedCount?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetNormDto
     */
    isDefault?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GetNormDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetNormDto
     */
    printText?: string | null;
}

/**
 * Check if a given object implements the GetNormDto interface.
 */
export function instanceOfGetNormDto(value: object): value is GetNormDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function GetNormDtoFromJSON(json: any): GetNormDto {
    return GetNormDtoFromJSONTyped(json, false);
}

export function GetNormDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetNormDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'condition': json['condition'] == null ? undefined : json['condition'],
        'confidenceInterval': json['confidenceInterval'] == null ? undefined : json['confidenceInterval'],
        'probability': json['probability'] == null ? undefined : json['probability'],
        'criticalValue': json['criticalValue'] == null ? undefined : json['criticalValue'],
        'group': json['group'] == null ? undefined : json['group'],
        'indicatorTest': json['indicatorTest'] == null ? undefined : GetIndicatorTestDtoFromJSON(json['indicatorTest']),
        'examinedCount': json['examinedCount'] == null ? undefined : json['examinedCount'],
        'isDefault': json['isDefault'] == null ? undefined : json['isDefault'],
        'description': json['description'] == null ? undefined : json['description'],
        'printText': json['printText'] == null ? undefined : json['printText'],
    };
}

export function GetNormDtoToJSON(value?: GetNormDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'condition': value['condition'],
        'confidenceInterval': value['confidenceInterval'],
        'probability': value['probability'],
        'criticalValue': value['criticalValue'],
        'group': value['group'],
        'indicatorTest': GetIndicatorTestDtoToJSON(value['indicatorTest']),
        'examinedCount': value['examinedCount'],
        'isDefault': value['isDefault'],
        'description': value['description'],
        'printText': value['printText'],
    };
}

